import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';
import { NbIconConfig, NbToastrService } from '@nebular/theme';

/**
 * Adds a default error handler to all requests.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private index = 0;

  constructor(private toastrService: NbToastrService) {}

  /**
   * Intercept http requests catching and handling errors
   * @param request HttpRequest
   * @param next HttpHandler
   * @returns Observable<HttpEvent<any>>
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      debounceTime(500),
      catchError((error) => {
        if (error.status === 0 && error.error instanceof ProgressEvent) {
          console.error('Connection time out or No internet connection! Check configuration.');
        }
        return this.errorHandler(error);
      })
    );
  }

  /**
   * Customize the default error handler here if needed
   * @param response incoming response from API
   * @private
   */
  private errorHandler(response: HttpEvent<any>): Observable<HttpEvent<any>> {
    this.showToastMessage(response);
    throw response;
  }

  private showToastMessage(response: any) {
    const iconConfig: NbIconConfig = { icon: 'alert-triangle-outline', pack: 'eva' };
    if (response.status && (response.status === 404 || response.status === 400)) {
      return;
    }
    if (response.status && response.status === 500) {
      this.showToast(response.statusText, response.message, {
        status: 'danger',
        hasIcon: true,
        icon: iconConfig,
        duration: 15000,
      });
    }
  }

  private showToast(message: string, title: string, config: any): void {
    this.index += 1;
    if (this.index <= 3) {
      this.toastrService.show(message, title, config);
    }
  }
}
